/** PACKAGE IMPORTS */
import React, { useMemo } from 'react';
import DataTable from 'react-data-table-component';
import { DataTableStyles, EmptyData, LoadingData } from '@/Theme';
import { Avatar, IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';

const List = ({
  listData,
  loading,
  handleView,
  handleEdit,
  count,
  size,
  setSize,
  page,
  setPage,
  setSort,
  setDirection,
}) => {
  // users = [];
  const columns = useMemo(
    () => [
      {
        name: 'Code',
        selector: row=>row.code,
        sortable: true,
      },
      {
        name: 'Description',
        selector: row=>row.description,
        sortable: true,
        grow: 6,
      },
      {
        name: 'Active',
        selector: row=>row.active,
        sortable: true,
        width: '100px',
        cell: (row) => {
          return row.active ? 'Yes' : 'No';
        },
      },
      {
        name: '',
        sortable: false,
        width: '56px',
        button: true,
        cell: (row) => {
          return (
            <IconButton onClick={() => handleEdit(row)}>
              <EditIcon />
            </IconButton>
          );
        },
      },
    ],
    []
  );
  const handlePageChange = (p) => {
    console.log('### handlePageChange', page, '--', p);
    setPage(p);
  };
  const handlePerRowsChange = (perPage, p) => {
    console.log('### handleRowsChange', perPage, p);
    setSize(perPage);
    setPage(p);
  };
  const handleSort = (sort, direction) => {
    console.log('### handleSort', sort, direction);
    setSort(sort.selector);
    setDirection(direction);
  };
  return (
    <>
      {loading && listData.length === 0 && <LoadingData />}
      {listData.length > 0 && (
        <DataTable
          className='pagination-custom'
          columns={columns}
          data={listData}
          noHeader
          onRowClicked={handleEdit}
          highlightOnHover
          customStyles={DataTableStyles}
          persistTableHead
          pagination={false}
          onChangeRowsPerPage={handlePerRowsChange}
          defaultSortField='name'
          defaultSortAsc={false}
          onSort={handleSort}
        />
      )}
      {!loading && !listData.length && <EmptyData />}
    </>
  );
};
export default List;
